import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem5CSECS1 = () => {
  const data = [
    {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSECS Sem - 5</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem5CSECS1